
import api from '@/api';

const namespaced = true;

const state = {
};

const mutations = {
};

const actions = {
  async fetchList(noop, { queryParams = {} }) {
    const { data: equipments } = await api.get(`/equipments`, {
      params: queryParams,
    });
    return equipments;
  },
  async fetchForClient(store, clientId) {
    const { data: equipments } = await api.get(`/equipments/client/${clientId}`);

    return equipments;
  },
  async fetchListForIntervention(store, interventionId) {
    const { data: equipments } = await api.get(`/equipments/intervention/${interventionId}`);

    return equipments;
  },
  async fetchOne(noop, id) {
    const { data: equipment } = await api.get(`/equipments/${id}`);

    return equipment;
  },
  async addEquipment(store, equipment) {
    const { data: dbEquipment } = await api.post(`/equipments`, equipment);

    return dbEquipment;
  },
  async updateEquipment(store, equipment) {
    const { data: dbEquipment } = await api.put(`/equipments/${equipment.id}`, equipment);

    return dbEquipment;
  },
  async removeEquipment(store, equipmentId) {
    await api.delete(`/equipments/${equipmentId}`);

    return Promise.resolve();
  },
};

const getters = {
};

export default {
  namespaced, state, mutations, actions, getters,
};
